import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../utl/models/Error";
import { EmployeesState } from "../models/EmployeesState";

const setErrorTelEmployee = (state: EmployeesState, action: PayloadAction<Error>) => {
    state.telError = action.payload.error;
}

export default setErrorTelEmployee;